import React from 'react';

interface ActionButtonProps {
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent) => void;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
  size?: 'small' | 'medium';
}

const ActionButton: React.FC<ActionButtonProps> = ({
  children,
  onClick,
  disabled = false,
  type = 'button',
  size = 'medium',
}) => {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    onClick?.(e);
  };

  const buttonClass = size === 'small' ? 'c-btn-action -small' : 'c-btn-action';

  return (
    <div className={buttonClass}>
      <button
        onClick={onClick ? handleClick : undefined}
        disabled={disabled}
        type={type}
      >
        {children}
      </button>
    </div>
  );
};

export default ActionButton;
